import { render, staticRenderFns } from "./FieldOrderCard.vue?vue&type=template&id=73fcf48f&scoped=true"
import script from "./FieldOrderCard.vue?vue&type=script&lang=js"
export * from "./FieldOrderCard.vue?vue&type=script&lang=js"
import style0 from "./FieldOrderCard.vue?vue&type=style&index=0&id=73fcf48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fcf48f",
  null
  
)

export default component.exports